import './polyfill';
import { AppRegistry } from 'react-native';
import App from '../mobile/App';

AppRegistry.registerComponent('Share', () => App);

AppRegistry.runApplication('Share', {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
